import React from "react";
import { Link, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

// Import local category images
import fresh from "../assets/Images/fresh.jpeg";
import leafy from "../assets/Images/leafy.jpeg";
import offer from "../assets/Images/offer.jpeg";
import fruits from "../assets/Images/fruits.jpg";
import idli from "../assets/Images/idli.jpeg";
import milk from "../assets/Images/milk.jpeg";
import grocery from "../assets/Images/grocery.png";

function Product() {
  const location = useLocation();

  // Categories from state or fallback to local default
  const categories = location.state?.categories || [
    { title: "Fresh Vegetables", image: fresh, itemCount: "24 items" },
    { title: "Leafy Vegetables", image: leafy, itemCount: "16 items" },
    { title: "Offer Items", image: offer, itemCount: "32 items" },
    { title: "Fresh Fruits", image: fruits, itemCount: "12 items" },
    { title: "Idli & Dosa Batter", image: idli, itemCount: "24 items" },
    { title: "Milk & Dairy", image: milk, itemCount: "16 items" },
    { title: "Grocery Items", image: grocery, itemCount: "32 items" },
  ];

  return (
    <>
      <Navbar />
      {categories.length > 0 ? (
        <div className="max-w-[1200px] mx-auto px-4 py-12">
          <h2 className="text-3xl font-bold mb-8 text-center">Available Categories</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
            {categories.map((cat, idx) => (
              <Link
                key={idx}
                to="/sku"
                state={{ category: cat.title }}
                className="bg-white p-4 rounded-lg shadow hover:shadow-lg transition-shadow cursor-pointer block no-underline text-current"
              >
                <img
                  src={cat.image}
                  alt={cat.title}
                  className="w-full h-40 object-cover rounded-md mb-4"
                />
                <h3 className="text-xl font-semibold mb-2">{cat.title}</h3>
                <p className="text-gray-600">{cat.itemCount}</p>
              </Link>
            ))}
          </div>
        </div>
      ) : (
        <p className="text-center text-gray-500 py-20">No categories available.</p>
      )}
      <Footer />
    </>
  );
}

export default Product;
